import React from "react";
import PropTypes from "prop-types";
import exportIcon from "../../../../assets/img/export-to-excel-icon.svg";

const ExportToExcelButton = ({ onClick, disabled = false }) => (
  <button
    type="button"
    className="rate-plans-derived-rate-page__export-btn"
    onClick={onClick}
    disabled={disabled}
    aria-label="Export to Excel"
  >
    <img src={exportIcon} alt="" className="export-btn__icon" />
    <span>Export to Excel</span>
  </button>
);

ExportToExcelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ExportToExcelButton;
